export default __webpack_public_path__ + "static/media/icon_07_databases.bff105fd.svg";